import { KitElement } from 'shared/kit/kit-element';
import { KIT_PATTERN_COLOR_COUNT, KitPattern } from 'shared/kit/kit-pattern';
import { theme } from 'styles/theme/theme';

export const DEFAULT_COLOR = theme.colors.SurfaceWhite;
export const DEFAULT_COLOR_2 = '#000000';
export const DEFAULT_PATTERN = KitPattern.SOLID;

/** Как выглядит один элемент комплекта: узор и его цвета. */
export interface KitElementState {
  pattern: KitPattern;
  colors: string[];
}

/** Комплект целиком — по состоянию на каждый элемент формы. */
export type KitOutfit = Record<KitElement, KitElementState>;

export function makeDefaultElementState(pattern = DEFAULT_PATTERN): KitElementState {
  const count = KIT_PATTERN_COLOR_COUNT[pattern];
  return { pattern, colors: count === 1 ? [DEFAULT_COLOR] : [DEFAULT_COLOR, DEFAULT_COLOR_2] };
}
